module.exports = __webpack_public_path__ + "static/media/preview_phone_12_A_Speaker.3087661b.svg";